export default [
  {
    name: 'batchVerfiy',
    path: '/verify/batchVerify',
    meta: { title: '批量核销', topNavName: '批量核销' },
    component: () =>
      import(
        /* webpackChunkName: "verification" */ '@/pages/agent/verify/batch.vue'
      ),
  },
  {
    name: 'verfiyRecord',
    path: '/verify/verifyRecord',
    meta: { title: '核销记录', topNavName: '核销记录' },
    component: () =>
      import(
        /* webpackChunkName: "verification" */ '@/pages/agent/verify/record.vue'
      ),
  },
  {
    name: 'verifyResult',
    path: '/verify/verifyResult',
    meta: { title: '核销结果', topNavName: '核销结果' },
    beforeEnter: (to, from, next) => {
      const nextTo = to
      /** @type {*{}} */
      let hasVerify = JSON.parse(
        sessionStorage.getItem('hasVerify') ||
          JSON.stringify({
            verifyVal: [],
            result: null,
          })
      )
      if (
        hasVerify?.verifyVal &&
        hasVerify.verifyVal.find(i => i == to.query.value) &&
        !to.query.hasVerify?.verifyVal
      ) {
        nextTo.query.hasVerify = { verifyVal: true }
        next(nextTo)
      } else {
        next()
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "verification" */ '@/pages/agent/verify/result.vue'
      ),
  },
  {
    name: 'AwardResult',
    path: '/verify/awardVerifyResult',
    meta: { title: '核销结果', topNavName: '核销结果' },
    component: () =>
      import(
        /* webpackChunkName: "verification" */ '@/pages/agent/verify/AwardResult.vue'
      ),
  },
  //   {
  //     name: 'sumVerify',
  //     path: '/agent/sumVerify',
  //     meta: { title: '核销数量', topNavName: '核销数量' },
  //     component: () =>
  //       import(
  //       /* webpackChunkName: "verification" */ '@/pages/agent/verify/amount.vue'
  //       )
  //   },
  // {
  //   name: 'verification',
  //   path: '/agent/verification',
  //   meta: { title: '核销工具', topNavName: '核销工具' },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "verification" */ '@/pages/agent/verify/index.vue'
  //     )
  // }
]
